import I18n from 'I18n';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import ActionsDropdownModalsAsync from 'card-preview-highlight-lib/crm_ui/profile/sidebar/highlight/ActionsDropdownModalsAsync';
import ActionsDropdownContentAsync from 'card-preview-highlight-lib/crm_ui/profile/sidebar/highlight/ActionsDropdownContentAsync';
import { useMemo, useState } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useGetIsUngated } from 'crm-cards-sdk/hooks/useGetIsUngated';
import { useGetIsScoped } from 'crm-cards-sdk/hooks/useGetIsScoped';
import { useCardContextValue } from '../state/CardContext';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { EllipsesIcon } from 'foundations-assets/icons/components/EllipsesIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownButton = props => {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, props, {
    use: "transparent",
    size: "sm",
    "aria-label": I18n.text('ObjectHighlightCard.actionsDropdownLabel'),
    children: /*#__PURE__*/_jsx(EllipsesIcon, {})
  }));
};
const ActionsDropdown = ({
  dataSeleniumTest = 'profile-settings-actions-btn'
}) => {
  var _subjectPermissionsRe2;
  const [hasOpened, setHasOpened] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showGdprExportModal, setShowGdprExportModal] = useState(false);
  const [showFlywheelCustomerRoadblockPanelUrl, setShowFlywheelCustomerRoadblockPanelUrl] = useState(null);
  const [showCreateExtensionPanelForFlywheelServiceObject, setShowCreateExtensionPanelForFlywheelServiceObject] = useState(false);
  const [showContactOptOutDialog, setShowContactOptOutDialog] = useState(false);
  const [showContactDoubleOptInDialog, setShowContactDoubleOptInDialog] = useState(false);
  const {
    asyncData: {
      subjectResult,
      subjectPermissionsResult
    }
  } = useCardContextValue();
  const subject = useMemo(() => {
    return subjectResult.data;
  }, [subjectResult.data]);
  const getIsUngated = useGetIsUngated();
  const getIsScoped = useGetIsScoped();
  const permissions = useMemo(() => {
    var _subjectPermissionsRe, _crmObject$objectType;
    const crmObject = (_subjectPermissionsRe = subjectPermissionsResult.data) === null || _subjectPermissionsRe === void 0 ? void 0 : _subjectPermissionsRe.crmObject;
    if (!crmObject) {
      return null;
    }
    return {
      canCreate: (_crmObject$objectType = crmObject.objectTypePermissions) === null || _crmObject$objectType === void 0 ? void 0 : _crmObject$objectType.currentUserCanCreate,
      canEditSubject: crmObject.userPermissions.currentUserCanEdit,
      canDeleteSubject: crmObject.userPermissions.currentUserCanDelete,
      canMergeSubject: crmObject.userPermissions.currentUserCanMerge
    };
  }, [(_subjectPermissionsRe2 = subjectPermissionsResult.data) === null || _subjectPermissionsRe2 === void 0 ? void 0 : _subjectPermissionsRe2.crmObject]);
  const isLoading = subjectResult.loading || subjectPermissionsResult.loading;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Dropdown, {
      Button: DropdownButton,
      "data-selenium-test": dataSeleniumTest,
      onOpenChange: isOpen => {
        if (isOpen && !hasOpened) {
          setHasOpened(true);
        }
      },
      menuWidth: 240,
      marginInlineStart: "0",
      placement: "bottom right",
      children: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      }) : /*#__PURE__*/_jsx(ActionsDropdownContentAsync, {
        getIsUngated: getIsUngated,
        getIsScoped: getIsScoped,
        isPreview: false,
        showPreviewCustomization: false,
        onFlywheelCustomerRoadblockPanelUrlChange: setShowFlywheelCustomerRoadblockPanelUrl,
        showCreateExtensionPanelForFlywheelServiceObject: () => setShowCreateExtensionPanelForFlywheelServiceObject(true),
        subject: subject,
        showDeleteModal: () => setShowDeleteModal(true),
        showGdprExportModal: () => setShowGdprExportModal(true),
        showContactOptOutDialog: () => setShowContactOptOutDialog(true),
        showContactDoubleOptInDialog: () => setShowContactDoubleOptInDialog(true),
        hasDeleteAction: true,
        permissions: permissions
      })
    }), /*#__PURE__*/_jsx(ActionsDropdownModalsAsync, {
      renderImmediately: hasOpened,
      showFlywheelCustomerRoadblockPanelUrl: showFlywheelCustomerRoadblockPanelUrl,
      closeFlywheelCustomerRoadblockPanel: () => setShowFlywheelCustomerRoadblockPanelUrl(null),
      showCreateExtensionPanelForFlywheelServiceObject: showCreateExtensionPanelForFlywheelServiceObject,
      closeCreateExtensionPanelForFlywheelServiceObject: () => setShowCreateExtensionPanelForFlywheelServiceObject(false),
      subject: subject,
      showDeleteModal: showDeleteModal,
      showGdprExportModal: showGdprExportModal,
      closeDeleteModal: () => setShowDeleteModal(false),
      closeGdprExportModal: () => setShowGdprExportModal(false),
      showContactOptOutDialog: showContactOptOutDialog,
      closeContactOptOutDialog: () => setShowContactOptOutDialog(false),
      showContactDoubleOptInDialog: showContactDoubleOptInDialog,
      closeContactDoubleOptInDialog: () => setShowContactDoubleOptInDialog(false)
    })]
  });
};
export default ActionsDropdown;